import React from "react";
import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";
import { DELOITTE_URL } from "@util/constant";

/**
 * Component to render Deloitte section on Partners page
 */
const DeloitteSection = (): React.ReactElement => {
  return (
    <div className="bg-gray-150" data-testid="deloitte-section-component">
      <AccordionV2
        testId="deloitte"
        className="border-x py-4"
        headerChildren={<EventsAwardsAccordionHeader title="Deloitte" />}
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4 pt-4">
          <p>
            Deloitte is a leading global provider of audit and assurance,
            consulting, financial advisory, risk advisory, tax and legal and
            related services. Our global network of member firms and related
            entities in more than 150 countries and territories (collectively,
            the “Deloitte organization”) serves four out of five Fortune Global
            500® companies.
          </p>

          <p>
            Deloitte SEA and the Deloitte firms in Australia, China, Japan, New
            Zealand, Taiwan and Korea have joined together to create Deloitte
            Asia Pacific. This increase in scale enables us to serve our clients
            more seamlessly across the region and provide them with innovative
            services from a wide range of geographies, businesses and industry
            sectors.
          </p>

          <p>
            Deloitte Asia Pacific Limited is a company limited by guarantee and
            a member firm of DTTL. Members of Deloitte Asia Pacific Limited and
            their related entities, each of which are separate and independent
            legal entities, provide services from more than 100 cities across
            the region, including Auckland, Bangkok, Beijing, Hanoi, Ho Chi Minh
            City, Hong Kong, Jakarta, Kuala Lumpur, Manila, Melbourne, Osaka,
            Shanghai, Singapore, Sydney, Taipei, Tokyo and Yangon.
          </p>

          <p>
            Learn how Deloitte&apos;s people make an impact that matters
            at&nbsp;
            <a
              className="text-blue-175 hover:text-gray-750"
              href={DELOITTE_URL}
              target="_blank"
              rel="noreferrer"
            >
              www.deloitte.com
            </a>
            .
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default DeloitteSection;
